import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SideBar from '../../../src/Components/ClientDashboard/Clientcommon/SideBar';
import Header from '../../../src/Components/ClientDashboard/Clientcommon/Header';
import Overview from '../../Components/ClientDashboard/ClientOverview/Overview';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/client/client_assets/css/sb-admin-2.min.css';
import '../../../src/pages/client/client_assets/css/common.css';
import '../../../src/pages/client/client_assets/css/responsive.css';
import '../../../src/pages/client/client_assets/css/Overview.css';
import HideText from '../../../src/Components/ClientDashboard/Clientcommon/HidePageText';

const OverviewPage = () => 
{



    const baseClass = 'container-fluid';
    const className = `${baseClass}`;


    const navigate = useNavigate();
    const location = useLocation();

    // useEffect(() => {
    //     const token = sessionStorage.getItem('userId');
    //     if (!token) {
    //         navigate('/');
    //     }
    // }, [navigate]);

    return (
        <div id="page-top">
            <div id="wrapper">
                <SideBar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content" className={className}>
                        <Header />
                        <Overview />
                    </div>
                </div>
            </div>

            <div className="modal fade" id="logoutModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
                            <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Select "Logout" below if you are ready to end your current session.
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
                            <a className="btn btn-primary" href="login.html">Logout</a>
                        </div>
                    </div>
                </div>
            </div>

            <HideText/>
        </div>
    );
};

export default OverviewPage;
